export const EXERCISE_PLAYING = "EXERCISE_PLAYING";
export const EXERCISE_IDLE = "EXERCISE_IDLE";
export const SIMULATION_IDLE = "SIMULATION_IDLE";
export const SIMULATION_STARTED = "SIMULATION_STARTED";
export const SIMULATION_ENDED = "SIMULATION_ENDED";
export const LAB_ID = 10;

export const IMG_SIZE = 96;
export const KEY_SIZE = 32;

export const STEP_COUNT = 20;
export const MIN_USER_ATTEMPTS = 6;
export const TRAINING_DURATION = 30;

export const COLORS = [
  ["tw-bg-[#ffeb00]", 0],
  ["tw-bg-[#ff2713]", 0],
  ["tw-bg-[#09da4f]", 0],
  ["tw-bg-[#9e8fe5]", 0],
  ["tw-bg-[#d67b41]", 0],
  ["tw-bg-[#86aedf]", 0],
];

export const NAMES = {
  "tw-bg-[#ffeb00]": "Yellow",
  "tw-bg-[#ff2713]": "Red",
  "tw-bg-[#09da4f]": "Green",
  "tw-bg-[#9e8fe5]": "Purple",
  "tw-bg-[#d67b41]": "Brown",
  "tw-bg-[#86aedf]": "Blue",
};

export const SIZE = 96;
export const SPAWN_INTERVAL = 2500;
export const SPEED_STEP = 10;
export const SPEED = 10;
export const DURATION_RANGE = [60, 120];

export const POPUP_MESSAGES = {
  ARROW_RIGHT_WRONG: "Please re-type your answer in the ArrowRight input.",
  ARROW_LEFT_WRONG: "Please re-type your answer in for the ArrowLeft input.",
  SUCCESS: "The repairs have successfully been implemented.",
  ARROW_LEFT_NOT_INCLUDED: "The 'ArrowLeft' input has been left empty",
  ARROW_RIGHT_NOT_INCLUDED: "The 'ArrowRight' input has been left empty.",
  INVALID_INTEGER: "The input you provided is not a number.",
  OUTSIDE_RANGE: "The number you provided is outside the specified range.",
};

export const POPUP_DELAY = 6000;
